import { forwardRef, ForwardedRef, MouseEventHandler, useCallback } from 'react'
import classNames from 'classnames'

import { LinkProps } from './types'
import { RouterLink } from './RouterLink'

export const Link = forwardRef<HTMLAnchorElement | HTMLSpanElement, LinkProps>(function Link(props, ref) {
    const {
        className,
        to,
        inactiveClassName,
        activeClassName,
        active = undefined,
        href,
        target,
        onClick,
        title,
        nonLinkElement,
        children,
    } = props

    const allClassNames = classNames(
        className,
        ((!!to && active === false) || (!to && !active)) && inactiveClassName,
        active === true && activeClassName
    )

    const handleLinkClick = useCallback(
        (evt: any) => {
            evt.stopPropagation()

            if (onClick) {
                onClick(evt)
            }
        },
        [onClick]
    )

    if (to) {
        return (
            <RouterLink {...props} onClick={handleLinkClick} className={allClassNames}>
                {children}
            </RouterLink>
        )
    }

    if (href) {
        return (
            <a
                ref={ref as ForwardedRef<HTMLAnchorElement>}
                onClick={handleLinkClick}
                href={href}
                target={target}
                className={allClassNames}
                title={title}
            >
                {children}
            </a>
        )
    }

    const Element = nonLinkElement || 'span'

    return (
        <Element
            ref={ref as ForwardedRef<HTMLSpanElement>}
            className={allClassNames}
            onClick={onClick as MouseEventHandler<HTMLSpanElement>}
            title={title}
        >
            {children}
        </Element>
    )
})
